import { render, staticRenderFns } from "./syslistchange.vue?vue&type=template&id=36766fe6&scoped=true"
import script from "./syslistchange.vue?vue&type=script&lang=js"
export * from "./syslistchange.vue?vue&type=script&lang=js"
import style0 from "./syslistchange.vue?vue&type=style&index=0&id=36766fe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36766fe6",
  null
  
)

export default component.exports